module.exports = __webpack_public_path__ + "img/CCS-logo.ef58bf9e.svg";